import React from "react";
import { processImagePath } from "../../util/Functions";
import CatalogContext from "../../contexts/CatalogContext";
import { useCatalogSelectionContext } from "../../hooks/useCatalogSelectionContext";

import "./OrganizationLogoNav.scss";

export default function OrganizationLogoNav() {

	const organization_logo_data = JSON.parse(localStorage.getItem('organization_member:data')) || undefined
	const [catalog] = React.useContext(CatalogContext);
	const CatalogSelectionContext = useCatalogSelectionContext();

	const logo_click = () => {
		if (!catalog) {
			CatalogSelectionContext.clearSearch();
		}
	}

	const logoSrc = organization_logo_data?.organization?.logo || organization_logo_data?.organization?.parent?.logo;
	const logoAlt = organization_logo_data?.organization?.name;
	
	return (
		<div data-component="OrganizationLogoNav">
			<a href={catalog?.initial_uri || '#'}>
				{!!logoSrc && (
					<div className="brand-logo">
						<img
							alt={logoAlt}
							className="brand-logo-img"
							src={processImagePath(logoSrc, "full")}
						/>
					</div>
				)}
				
				{!logoSrc && !!logoAlt && (
					<div>{logoAlt}</div>
				)}
			</a>
		</div>
	)
}